import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import moment from "moment";

import {LeadFilterDataAPI} from "./../../../API/Caller/LeadAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
import Paginate from "./../../../utils/Pagination";
import Layout from "./../Layout";
import ContentLoader from "../../../utils/ContentLoader";


const LeadFilter = () =>{

    const {filtertype} = useParams();
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);

    const perpagedata = 20;


    useEffect(() => {

        LeadFilterDataAPI(setLeads, setLoading, currentPage, perpagedata, setPageCount, filtertype);
        

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

        //setIsFilterPagination(true);

        //handleFilterLeads();
    }


    return(
    <Layout>
        <div className="content">

            <div className="row">
                <div className="col-md-12">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                {filtertype === 'freshlead' ?
                                    <h4 className="page-title">Fresh Leads</h4>
                                :
                                    (filtertype === 'warmleads' ?
                                        <h4 className="page-title">Warm Leads</h4>
                                    :
                                        (filtertype === 'contactedleads' ?
                                            <h4 className="page-title">Contacted Leads</h4>
                                        :
                                            (filtertype === 'deadleads' ?
                                                <h4 className="page-title">Dead Leads</h4>
                                            :
                                                (filtertype === 'coldleads' ?
                                                    <h4 className="page-title">Cold Leads</h4>
                                                :
                                                    (filtertype === 'attemptleads' ?
                                                        <h4 className="page-title">Attempt to Contact Leads</h4>
                                                    :
                                                        (filtertype === 'enrolledleads' ?
                                                            <h4 className="page-title">Enrolled Leads</h4>
                                                        :
                                                            (filtertype === 'totalleads' ?
                                                                <h4 className="page-title">Total Leads</h4>
                                                            :
                                                                <></>
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                }
                            </div>
                            <div className="col-4 text-end">

                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="card">

                        <div className="card-body">

                            <div className="table-responsive table-wrapper">
                                {loading ?
                                    <div>
                                        <ContentLoader />
                                    </div>
                                :
                                <table className="table table-data-section" id="">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Contact</th>
                                            <th>Location</th>
                                            <th>Program</th>
                                            <th>Institute</th>
                                            <th>Lead Status</th>
                                            <th>Assigned Date</th>
                                            <th>Created Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    {leads && leads.length > 0  ?
                                        leads.map(lead =>
                                        (

                                            <tr key={lead.id}>
                                                <td>
                                                    <Link to={`/caller/lead-profile/${lead.id}`} className="">
                                                        {lead.name}
                                                    </Link>
                                                </td>

                                                <td>{lead.email}</td>
                                                <td>{lead.contact}</td>
                                                <td>{lead.location}</td>
                                                <td>{lead.program}</td>
                                                <td>{lead.institute}</td>
                                                <td>
                                                    {lead.leadstatus ?
                                                        <span class="badge badge-tag badge-purple-light">{lead.leadstatus}</span>
                                                    :
                                                        <span>-</span>
                                                    }
                                                </td>
                                                <td>
                                                    {lead.assigned_at !== "" && lead.assigned_at !== null ?
                                                        moment(lead.assigned_at).format('DD-MM-YYYY h:mm')
                                                    :
                                                        <>-</>
                                                    } 
                                                </td>

                                            </tr>
                                        ))

                                        :

                                            <tr>
                                                <td colSpan="9">
                                                    <p>No record found...</p>
                                                </td>
                                            </tr>
                                    }

                                    </tbody>
                                </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {pagecount > 1 ?
                <div className="pagination-section mt-3">

                    <nav>
                        <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                    </nav>
                </div>
                :
                    <></>
                }
            </div>
        </div>
    </Layout>
    )
}

export default LeadFilter;
